import { RichText } from '@/components/richText/RichText';
import type { RichtextStoryblok } from '@/types/component-types-sb';

type LabelProps = {
  className?: string;
  text: string | RichtextStoryblok | undefined;
};

const Label: React.FC<LabelProps> = (props) => {
  if (!props.text) return;

  return typeof props.text === 'string' ? props.text : <RichText text={props.text} />;
};

export default Label;
